import { PhoneNumber } from '~/utils/PhoneNumber'
import type { CountryPrefix } from './CountryPrefix'

const names = new Intl.DisplayNames(['en'], { type: 'region' })

// flagcdn.com serves a flag SVG per ISO 3166-1 alpha-2 code (lowercased) --
// no npm dependency needed, and PhoneInput.vue already handles a broken/404
// flag via `onCountryFlagError` + `erroredFlags`, so a CDN miss degrades to
// the existing placeholder icon rather than breaking the picker.
const flagUrl = (countryCode: string): string =>
  `https://flagcdn.com/${countryCode.toLowerCase()}.svg`

export const getCountryPrefixes = (): CountryPrefix[] =>
  PhoneNumber.regions().map(({ callingCode, code }) => ({
    flag: flagUrl(code),
    prefix: callingCode,
    code,
    name: names.of(code) ?? code,
    code_2: code
  }))
